import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import useModal from '@hooks/ui/useModal';
import { useFlow } from '@router/stackflow';

import img from './img.png';
import styles from './styles.module.scss';
import ExternalShopModal from '../../ExternalShopModal';

function MyMenu() {
    const { openModal } = useModal();
    const { push } = useFlow();
    const handlerClick = () => {
        push('ExternalShopModal', { href: '/purchase' });
    };
    return (
        <Row className={styles.container} spacing={16}
            onClick={handlerClick} >
            <Image src={img} alt='상품'
                width={64}
                height={64} />
            <Column align='flex-start' fullWidth spacing={5}>
                <Text>
                    겨울에도
                    당연히 얼죽아지
                </Text>
                <Text color={colors.gray6}
                    className={styles.option} >
                    일회용컵 사용 ㅣ ICE
                </Text>
                <Row>
                    <Text size='lg' fontWeight='bold'>1,600</Text>
                    <Text className={styles.unit}>원</Text>
                </Row>
            </Column>
        </Row>
    );
}
export default MyMenu;
